import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

export const CountdownTimer = ({ orderDate, isAccepted, sellerDetails }) => {
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const start = new Date(orderDate);
      const diff = Math.floor((now - start) / 1000);
      setTimer(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, [orderDate]);
  const getBackgroundColor = () => {
    if (timer <= 60) return 'green-label';
    if (timer <= 180) return 'orange-label';
    return 'red-label';
  };

  return (
    <div
      className={clsx(
        'text-capitalize colored-label green-label',
        getBackgroundColor()
      )}
    >
      {Math.floor(timer / 3600) > 0 ? `${Math.floor(timer / 3600)}h` : ''}{' '}
      {Math.floor((timer % 3600) / 60)}m {timer % 60}s
    </div>
  );
};
